import {
  ErrorResultModel,
  UserDataModel,
  EditUserModel,
  IEditUserModel,
  IIndividualRegistration,
  IIndividualConsigneeReturnModel,
  IndividualConsigneeReturnModel,
  IndividualConsigneePartialUpdateModel1,
} from 'Core/Api/UserManagement/Api';
import Utility from 'Core/Utility';
import { SecuredUserManagementClient } from 'Core/Api/UserManagement/SecuredUserManagementClient';

export class UpdateUserProfileFormHandler {
  RequestGetUserProfile(): Promise<IIndividualConsigneeReturnModel> {
    const client = new SecuredUserManagementClient();
    var userProfile: IIndividualConsigneeReturnModel;
    client.DisableToken = false;
    client.showLoading = true;
    client.handleGeneralError = true;

    return client.userManagement_GetConsigneeDetails().then(x => {
      if (x.tRN !== undefined) {
        userProfile = {
          primaryUserEmailAddress: x.primaryUserEmailAddress,
          firstName: x.firstName,
          lastName: x.lastName,
          customerCode: x.customerCode,
          tRN: x.tRN,
          addressLine1: x.addressLine1,
          addressLine2: x.addressLine2,
          addressLine3: x.addressLine3,
          parish: x.parish,
          postalCode: x.postalCode,
          country: x.country,
          mobilePhoneNumber: x.mobilePhoneNumber,
        };
      }
      return userProfile;
    });
  }

  UpdateUserProfile(updateModel: IndividualConsigneePartialUpdateModel1) {
    const client = new SecuredUserManagementClient();

    client.DisableToken = false;
    client.showLoading = true;
    client.handleGeneralError = true;

    return client.userManagement_UpdateConsigneeDetails(updateModel)
      .catch(Utility.formatError);
  }
}

export default UpdateUserProfileFormHandler;
